import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { activityTypeList, activityTypeDel } from "@/api/gmtool/packageCode";
import addtypeActivities from "./components/addtypeActivities";
import activities from "./mixins/activities";
export default {
  name: "typeActivities",
  mixins: [activities],
  components: {
    addtypeActivities: addtypeActivities
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.getList();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      this.reqLoading = true;
      activityTypeList().then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    addClick: function addClick() {
      this.$refs.addtypeActivities.open();
      this.lodclickOperationLog('add-activitie', this.$t('clickAddActivityTypeBtn'));
    },
    uptype: function uptype(row) {
      this.$refs.addtypeActivities.open(row);
      this.lodclickOperationLog('upd-config', this.$t('clickModifyActivityTypeBtn'));
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.lodclickOperationLog('del-config', this.$t('clickDeleteActivityTypeBtn'));
      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                activityTypeDel({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this3.getList();

                    _this3.$bus.$emit('nameUpd', id);

                    _this3.$message({
                      type: "success",
                      message: _this3.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};